import React from "react";
import componentSize from "react-component-queries";
import ReactDropzone from "react-dropzone";
import { supportedImages } from "_constants";
import cx from "classnames";
import PropTypes from "prop-types";
import Upload from "rialto-icons/Upload";

import Translate from "utils/translate";

import ImagePreview from "./ImagePreview";

import styles from "./Dropzone.css";

const { t } = new Translate("Dropzone");

export class Dropzone extends React.Component {
  constructor(props) {
    super(props);

    this.state = { file: this.props.file };
    this.onDrop = this.onDrop.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.file) this.setState({ file: nextProps.file });
  }

  componentWillUnmount() {
    if (this.state.preview) URL.revokeObjectURL(this.state.preview);
  }

  onDrop(files) {
    const { onChange, onError } = this.props;
    const file = files[0];

    if (file) {
      const preview = URL.createObjectURL(file);

      return this.setState({ file, preview }, () => onChange(file, preview));
    }

    return onError();
  }

  render() {
    const {
      accept,
      children,
      isEnabled,
      isMultiple,
      isPicture,
      isPreviewable,
      isRounded,
      placeholder,
      width,
    } = this.props;
    const { file, preview } = this.state;
    const isSmall = width < 250;
    const placehold = placeholder || (isPicture ? t("placeholderPicture") : t("placeholder"));
    const acceptedTypes = accept || (isPicture ? supportedImages : undefined);

    return (
      <div
        className={cx(styles.root, { [styles.small]: isSmall })}
        style={{ height: isSmall ? `${width}px` : "auto" }}
      >
        <ReactDropzone
          accept={acceptedTypes}
          multiple={isMultiple}
          onDrop={isEnabled ? this.onDrop : undefined}
        >
          {({ getInputProps, getRootProps, isDragActive }) => {
            const isPicturePreview = isPicture || (file && file.type.startsWith("image"));
            const isDroppable = isEnabled && (!children || isDragActive);

            return (
              <div
                {...getRootProps()}
                className={cx(styles.dropzone, {
                  [styles.active]: isDragActive,
                  [styles.enabled]: isDroppable,
                  [styles.previewed]: file && isPicturePreview,
                  [styles.rounded]: isRounded,
                })}
                style={children ? {} : { height: isSmall ? `${width}px` : "70px" }}
              >
                <>
                  {isDroppable && <input {...getInputProps()} />}
                  {file && isPreviewable && (
                    <div className={styles.preview}>
                      {isPicturePreview ? <ImagePreview url={preview || file.url} /> : file.name}
                    </div>
                  )}
                  {!file && isDroppable && (
                    <div className={styles.placeholder}>
                      <Upload />
                      {!isSmall && placehold}
                    </div>
                  )}
                </>
                {children && <div className={styles.children}>{children}</div>}
              </div>
            );
          }}
        </ReactDropzone>
        {isEnabled && placehold && isSmall && (
          <div className={styles.placeholderText}>{placehold}</div>
        )}
      </div>
    );
  }
}

Dropzone.propTypes = {
  accept: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  file: PropTypes.shape({ preview: PropTypes.string }),
  placeholder: PropTypes.string,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  isEnabled: PropTypes.bool,
  isMultiple: PropTypes.bool,
  isPicture: PropTypes.bool,
  isPreviewable: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRounded: PropTypes.bool,
};

Dropzone.defaultProps = {
  isEnabled: true,
  isPreviewable: true,
};

export default componentSize(({ width }) => ({ width }))(Dropzone);
